const fmt = (v) => (v === true ? "Yes" : v === false ? "No" : v === null || v === undefined || v === "" ? "—" : String(v));

export const HireChangeHistory = ({ history = [] }) => (
  <div className="border-t border-zinc-200 pt-3" data-testid="hire-change-history">
    <div className="text-xs font-bold uppercase tracking-wider text-zinc-500 mb-2">Change history</div>
    {history.length === 0 ? (
      <p className="text-xs text-zinc-400">No edits yet.</p>
    ) : (
      <ul className="space-y-2 max-h-40 overflow-y-auto">
        {[...history].reverse().map((h, i) => (
          <li key={i} className="text-xs text-zinc-600" data-testid={`hire-history-entry-${i}`}>
            <span className="font-semibold text-zinc-800">{h.by_name || "Someone"}</span>
            <span className="text-zinc-400"> · {h.at ? new Date(h.at).toLocaleString() : ""}</span>
            <ul className="ml-3 mt-0.5">
              {h.changes.map((c, j) => (
                <li key={j}><span className="font-semibold">{c.field}:</span> {fmt(c.from)} → {fmt(c.to)}</li>
              ))}
            </ul>
          </li>
        ))}
      </ul>
    )}
  </div>
);
